import api from './apiReduxMiddleware'

export default api
